<template>
  <div class="device-tab-page">
    <management-table
      title="控制器充电数据"
      embedded
      :data="tableData"
      :loading="loading"
      :current-page="query.pageNum"
      :page-size="query.pageSize"
      :total="total"
      empty-text="暂无充电数据"
      @current-change="onPageChange"
    >
      <template slot="filters">
        <div class="search-item">
          <label class="search-label">电站名称:</label>
          <el-select v-model="query.stationId" class="search-select" clearable filterable
            :filter-method="filterStation" @visible-change="onStationDropdownVisible"
            placeholder="请选择或输入电站名称">
            <el-option v-for="item in stationList" :key="item.id"
              :label="item.stationName" :value="item.id" />
          </el-select>
        </div>
        <div class="search-item">
          <label class="search-label">控制器选择:</label>
          <el-select v-model="query.id" class="search-select" clearable filterable placeholder="请选择控制器">
            <el-option
              v-for="item in deviceList"
              :key="item.id"
              :label="item.deviceName"
              :value="item.id"
            />
          </el-select>
        </div>
      </template>

      <template slot="actions">
        <el-button type="primary" icon="el-icon-search" class="search-btn" @click="serch">搜索</el-button>
      </template>

      <template slot="columns">
          <el-table-column type="index" fixed="left" width="50" label="序号" align="center" />
          <el-table-column label="电站名称" prop="stationName" min-width="140" align="center" show-overflow-tooltip />
          <el-table-column label="控制器" prop="deviceName" min-width="140" align="center" show-overflow-tooltip />
          <el-table-column label="充电电压" min-width="120" align="center">
            <template slot-scope="scope"><span v-if="scope.row.bcdy != null">{{ scope.row.bcdy }}V</span></template>
          </el-table-column>
          <el-table-column label="标称电压" min-width="120" align="center">
            <template slot-scope="scope"><span v-if="scope.row.gfdy != null">{{ scope.row.gfdy }}V</span></template>
          </el-table-column>
          <el-table-column label="过放电压" min-width="120" align="center">
            <template slot-scope="scope"><span v-if="scope.row.cddy != null">{{ scope.row.cddy }}V</span></template>
          </el-table-column>
          <el-table-column label="过充电压" min-width="120" align="center">
            <template slot-scope="scope"><span v-if="scope.row.gcdy != null">{{ scope.row.gcdy }}V</span></template>
          </el-table-column>
          <el-table-column label="低压恢复电压" min-width="140" align="center">
            <template slot-scope="scope"><span v-if="scope.row.dyhfdy != null">{{ scope.row.dyhfdy }}V</span></template>
          </el-table-column>
          <el-table-column label="过充恢复电压" min-width="140" align="center">
            <template slot-scope="scope"><span v-if="scope.row.gchfdy != null">{{ scope.row.gchfdy }}V</span></template>
          </el-table-column>
          <el-table-column label="数据时间" prop="uploadTime" width="170" align="center" show-overflow-tooltip />
          <el-table-column label="操作" fixed="right" width="90" align="center">
            <template slot-scope="scope">
              <span class="table-operate" @click="formObject = scope.row; showInfo = true;">查看</span>
            </template>
          </el-table-column>
      </template>
    </management-table>

    <el-dialog
      title="数据详情"
      :visible.sync="showInfo"
      @close="showInfo = false"
      width="850px"
      class="custom-dialog"
    >
      <div class="dialog-content">
        <el-row class="dialog-item">
          <el-col :span="12"><div class="dialog-label">电站名称：</div><div class="dialog-value">{{ formObject.stationName }}</div></el-col>
          <el-col :span="12"><div class="dialog-label">控制器：</div><div class="dialog-value">{{ formObject.deviceName }}</div></el-col>
        </el-row>
        <el-row class="dialog-item">
          <el-col :span="12"><div class="dialog-label">充电电压：</div><div v-if="formObject.bcdy != null" class="dialog-value">{{ formObject.bcdy }}V</div></el-col>
          <el-col :span="12"><div class="dialog-label">标称电压：</div><div v-if="formObject.gfdy != null" class="dialog-value">{{ formObject.gfdy }}V</div></el-col>
        </el-row>
        <el-row class="dialog-item">
          <el-col :span="12"><div class="dialog-label">过放电压：</div><div v-if="formObject.cddy != null" class="dialog-value">{{ formObject.cddy }}V</div></el-col>
          <el-col :span="12"><div class="dialog-label">过充电压：</div><div v-if="formObject.gcdy != null" class="dialog-value">{{ formObject.gcdy }}V</div></el-col>
        </el-row>
        <el-row class="dialog-item">
          <el-col :span="12"><div class="dialog-label">低压恢复电压：</div><div v-if="formObject.dyhfdy != null" class="dialog-value">{{ formObject.dyhfdy }}V</div></el-col>
          <el-col :span="12"><div class="dialog-label">过充恢复电压：</div><div v-if="formObject.gchfdy != null" class="dialog-value">{{ formObject.gchfdy }}V</div></el-col>
        </el-row>
        <el-row class="dialog-item">
          <el-col :span="12"><div class="dialog-label">数据时间：</div><div class="dialog-value">{{ formObject.uploadTime }}</div></el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ManagementTable from '../../components/ManagementTable.vue';

export default {
  name: 'deviceOneDianBiao',
  components: {
    ManagementTable
  },
  props: {
    id: {
      required: false,
      type: Number
    }
  },
  data() {
    return {
      showInfo: false,
      loading: false,
      formObject: {},
      tableData: [],
      total: 0,
      query: {
        pageNum: 1,
        pageSize: 9,
        deviceType: 1,
        id: null,
        stationId: null
      },
      deviceList: [],
      allStationList: [],
      stationList: []
    };
  },
  mounted() {
    if (this.id != null) this.query.id = this.id;
    this.loadStationList();
    this.loadAllList();
    this.loadPage();
  },
  methods: {
    onPageChange(val) {
      this.query.pageNum = val;
      this.loadPage();
    },
    serch() {
      this.query.pageNum = 1;
      this.loadPage();
    },
    loadPage() {
      this.loading = true;
      this.$request.post('/api/device/gf/cd/page', this.query).then(response => {
        if (response.data.result) {
          this.tableData = response.data.data.list;
          this.total = response.data.data.totalCount;
        } else {
          this.$Message.error('获取电池电压参数失败,请联系管理员!');
        }
      }).catch(() => {
        this.$Message.error('网络异常，获取电池电压参数失败！');
      }).finally(() => {
        this.loading = false;
      });
    },
    loadStationList() {
      this.$request.get('/api/power/station/options').then(response => {
        if (response.data.result) {
          this.allStationList = response.data.data || [];
          this.stationList = this.allStationList.slice();
        } else {
          this.$Message.error('获取电站列表失败,请联系管理员!');
        }
      }).catch(() => {
        this.$Message.error('网络异常，获取电站列表失败！');
      });
    },
    filterStation(query) {
      const keyword = String(query || '').trim().toLocaleLowerCase();
      this.stationList = keyword ? this.allStationList.filter(item =>
        String(item.stationName || '').toLocaleLowerCase().includes(keyword)
      ) : this.allStationList.slice();
    },
    onStationDropdownVisible(visible) {
      if (visible) this.stationList = this.allStationList.slice();
    },
    loadAllList() {
      const queryForm = { pageNum: 1, pageSize: 10000 };
      this.$request.post('/api/device/page', queryForm).then(response => {
        if (response.data.result) {
          this.deviceList = response.data.data.list;
        } else {
          this.$Message.error('获取设备列表失败,请联系管理员!');
        }
      }).catch(() => {
        this.$Message.error('网络异常，获取设备列表失败！');
      });
    }
  }
};
</script>

<style src="./deviceOneTabShared.css" scoped></style>
